import React from 'react';
interface CardProps {
  children: React.ReactNode;
  className?: string;
  hoverEffect?: boolean;
}
export function Card({
  children,
  className = '',
  hoverEffect = true
}: CardProps) {
  return <div className={`
        glass-card rounded-xl p-6 transition-all duration-500
        ${hoverEffect ? 'hover:-translate-y-2' : ''}
        ${className}
      `} data-id="element-280">
      {children}
    </div>;
}